import { getIcon } from './getIcon';

export const getSportIcon = (sport: string) => {
  if (!!sport) {
    return getIcon(
      sport.toUpperCase(),
      'sports',
      `../../../../assets/icons/sports/ESPORTS.svg`,
    );
  }
  return require('../../../../assets/icons/sports/ESPORTS.svg');
};
